import { Component, ElementRef, ViewChild, inject, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { MessageModule } from "primeng/message";
import { BqaImageItem } from "../../../../../../../domains/media/components/images-modal/bqa-image-item";
import { ImageAnnotatedCallback, ImagesModalComponent } from "../../../../../../../domains/media/components/images-modal/images-modal.component";
import { ImageCompressionPipelineService } from "../../../../../../../domains/media/services/image-compression-pipeline.service";

@Component({
  selector: "app-photo-grid",
  standalone: true,
  imports: [CommonModule, DialogModule, MessageModule],
  templateUrl: "./photo-grid.component.html",
  styleUrls: ["./photo-grid.component.scss"]
})
export class PhotoGridComponent {
  galleryItems = input.required<BqaImageItem[]>();
  /** When true, the last photo can be deleted (e.g. BQ1 items, which don't require photos). */
  allowDeleteLastImage = input<boolean>(false);
  /**
   * Enables Annotate in the image modal. A callback rather than an output because the modal
   * needs the replacement's fileIdentifier back; see {@link ImageAnnotatedCallback}.
   */
  annotateImage = input<ImageAnnotatedCallback>();
  /** Emitted with the files picked from the upload input. */
  filesSelected = output<File[]>();
  imageDeleted = output<string>();

  private dialog = inject(Dialog);
  imageCompressionPipelineService = inject(ImageCompressionPipelineService);

  @ViewChild("fileInput", { static: false }) fileInput!: ElementRef<HTMLInputElement>;

  onPhotoClicked(index: number): void {
    const annotateImage = this.annotateImage();
    this.dialog.open<string>(ImagesModalComponent, {
      data: {
        images: this.galleryItems(),
        index,
        isIssue: true,
        allowDeleteLastImage: this.allowDeleteLastImage(),
        onDeleted: async (fileIdentifier: string) => this.imageDeleted.emit(fileIdentifier),
        ...(annotateImage ? { onAnnotated: annotateImage } : {}),
        backdropClass: "images-modal-backdrop"
      }
    });
  }

  onUploadPhoto(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  handleFiles(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files ? Array.from(target.files) : [];
    // Reset so picking the same file again still fires `change`.
    target.value = "";

    if (files.length > 0) {
      this.filesSelected.emit(files);
    }
  }

  onMediaGridWheel(event: WheelEvent): void {
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const hasHorizontalOverflow = target.scrollWidth > target.clientWidth;
      if (hasHorizontalOverflow) {
        event.preventDefault();
        target.scrollLeft += event.deltaY;
      }
    }
  }
}
